import * as React from 'react';
import Skeleton from './Skeleton';
import './SaveViewSkeleton.scss';

export const renderFileSkeletons = (count) => {
  return (<>{[...Array(count)].map((e, i) => <div key={`dummy-${i}`} className={`skeleton-componentItem`}>
    <Skeleton height={'24px'} width={'24px'}/>
    <div className='skeleton-tableContainer'>
      <Skeleton height={'15px'} width={'80%'} className={'noMargin'}/>
    </div>
    <div className='skeleton-icons'>
      <Skeleton height={'15px'} width={'15px'} margin={'12px 0px 0px 0px'}/>
    </div>
  </div>)}</>);
};
